module.exports = __webpack_public_path__ + "static/img/exercise.c0998fe7.svg";